import { Typography } from "antd";
import InternalLink from "components/InternalLink";
import { marked } from "marked";
import React from "react";
import { transformComment } from "utils/commentUtil";
import parseHtml from "utils/parserUtil";
import ACLink from "ac-components/ACLink/ACLink";
import ACButton from "ac-components/ac-button/ACButton";
import ExternalIcon from "ac-components/ac-icons/ExternalIcon";
import "./AnyaVisualizationCodeBlock.less";

const { Text } = Typography;

const AnyaVisualizationCodeBlock = ({ showVisualization, visualisation, onClose }) => {
    if (!showVisualization || !visualisation) return null;

    const { status, codeBlock, filePath, fileLink, scm } = visualisation;

    // Get SCM icon based on type
    const getSCMIcon = (scmType) => {
        const iconMap = {
            'GITHUB': '/images/github.svg',
            'GITLAB': '/images/gitlab.svg',
            'AZURE_REPOS': '/images/azurerepos.svg',
            'BITBUCKET': '/images/bitbucket.svg'
        };
        return iconMap[scmType] || '/images/github.svg';
    };

    // Get SCM specific integration path
    const getSCMIntegrationPath = (scmType) => {
        const pathMap = {
            'GITHUB': '/integrations?tab=scm&tool=github',
            'GITLAB': '/integrations?tab=scm&tool=gitlab',
            'AZURE_REPOS': '/integrations?tab=scm&tool=azure-repos',
            'BITBUCKET': '/integrations?tab=scm&tool=bitbucket'
        };
        return pathMap[scmType] || '/integrations';
    };

  // Render success state with code block using existing transformComment infrastructure
  const renderSuccessState = () => {
    // Create markup from the codeBlock using marked
    const createMarkup = () => {
      return marked.parse(codeBlock || "");
    };

    return (<>
        <div className="anya-codeblock-file-info">
          <img
            src={getSCMIcon(scm)}
            alt={scm}
            className="font-size-24 m-r-xs"
            style={{ width: 16, height: 16 }}
          />
          {fileLink ? (
            <ACLink primary={false}
              href={fileLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              {filePath}
            </ACLink>
          ) : (
            <Text className="anya-codeblock-filepath">{filePath}</Text>
          )}
          <ExternalIcon className="m-l-xs" />
        </div>
        <div className="anya-codeblock-wrapper">
          <div className="anya-codeblock-content">
            {parseHtml(createMarkup(), { transform: transformComment, trim: true,})}
          </div>
        </div>
      </>
    );
  };

// Render config repo state (no repo connected)
const renderConfigRepoState = () => (
    <div className="anya-codeblock-message-card anya-codeblock-config-card">
      <div className="anya-codeblock-message-content">
        <div className="anya-codeblock-message-header">
          <Text strong>Contextual remediation</Text>
          <div className="anya-codeblock-message-body">
            <Text className="anya-codeblock-config-text">
              Connect a code repository to get more contextual and accurate
              remediation.
            </Text>
          </div>
        </div>
        <div className="anya-codeblock-message-actions">
        <InternalLink to={`/integrations`}>
          <ACButton
            size="small"
            type="outline"
            className="anya-codeblock-connect-btn"
          >
        Connect
          </ACButton>
        </InternalLink>
          <div className="anya-codeblock-learn-more-wrapper m-t-sm">
            <ACLink href="https://support.armorcode.com/hc/en-us/articles/31876424764563-Overview-Integrations">
              Learn more
            </ACLink>
          </div>
        </div>
        {onClose && (
          <button onClick={onClose} className="anya-codeblock-close-button" aria-label="Close">
            &times;
          </button>
        )}
      </div>
    </div>
  );

  // Render error state (unable to read file)
  const renderErrorState = () => (
    <div className="error-container">
      <div className="message-container">
          <Text strong className="message-header text-default">
            Unable to read file
          </Text>
            <Text className="message-text text-default">
              Check code repository configuration and retry
            </Text>
      </div>
      <InternalLink to={'/integrations'}>
      <ACButton
        size="small"
        type="outline"
        className="anya-codeblock-view-config-btn"
      >
        View Config
      </ACButton>
      </InternalLink>
      {onClose && (
          <button onClick={onClose} className="anya-codeblock-close-button" aria-label="Close">
            &times;
          </button>
        )}
    </div>
  );

  // Render based on status
  switch (status) {
    case "SUCCESS":
      return renderSuccessState();
    case "CONFIG_REPO":
      return renderConfigRepoState();
    case "ERROR":
      return renderErrorState();
    default:
      return null;
  }
};

export default AnyaVisualizationCodeBlock;